import { render, staticRenderFns } from "./Bytedance-Button.vue?vue&type=template&id=26a4fe5b&scoped=true"
import script from "./Bytedance-Button.vue?vue&type=script&lang=js"
export * from "./Bytedance-Button.vue?vue&type=script&lang=js"
import style0 from "./Bytedance-Button.vue?vue&type=style&index=0&id=26a4fe5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a4fe5b",
  null
  
)

export default component.exports